var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{'form__submit--activeState': _vm.isActive},on:{"click":function($event){$event.preventDefault();return _vm.submit()}}},[_vm._v(_vm._s(_vm.buttonText))])
}
var staticRenderFns = []

export { render, staticRenderFns }